import { ChevronRight } from "lucide-react"
import { useNavigate } from "react-router-dom"
import './cardProfessor.css'

export default function CardProfessor({professor}){
    const navigate = useNavigate()
    return(
        <div className="card-professor" onClick={() => {
            navigate(`/professores/${professor.id}`,{state:professor})
        }}>
            <div className="card-avatar">{professor.nome[0]}</div>
            <div className="card-info">
                <span className="card-nome">{professor.nome}</span>
                <span className="card-turma">{professor.turmaNome ? professor.turmaNome:'Sem turma'}</span>
            </div>
            <ChevronRight className="card-arrow" size={20} />
        </div>
    )
}